import React, { Component } from "react";
import { Modal, Button } from "react-bootstrap";

class DeleteModal extends Component {
  render() {
    return (
      <Modal show={this.props.showModal} onHide={this.props.onHideModal}>
        <Modal.Header closeButton>
          <Modal.Title>Delete {this.props.type}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          Are you sure you want to delete {this.props.type} <strong>"{this.props.name}"</strong>?
        </Modal.Body>
        <Modal.Footer>
          <Button className="btn-danger" onClick={this.props.confirm}>
            Yes
          </Button>
          <Button onClick={this.props.onHideModal}>No</Button>
        </Modal.Footer>
      </Modal>
    );
  }
}

export default DeleteModal;



// WEBPACK FOOTER //
// ./src/containers/Admin/AdminMainContent/Common/DeleteModal.js